/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { getFormattedDate } from '@/utils/date/formatDate';
import { translateMonthToSpanish } from '@/components/AZCustomComponent/Store/helpers';

/**
 * Formats a deal expiration date according to the locale
 * @param expirationDate - ISO date string
 * @param locale - Locale string (e.g., 'en-US', 'es-MX')
 * @returns Formatted date string
 */
export const formatDealExpirationDate = (expirationDate: string, locale: string): string => {
  const spanishMonth = translateMonthToSpanish(getFormattedDate(expirationDate, 'MMMM'));
  const usMonth = getFormattedDate(expirationDate, 'MMMM');

  return locale === 'es-MX'
    ? getFormattedDate(expirationDate, 'DD MMMM, YYYY').replace(usMonth, spanishMonth)
    : getFormattedDate(expirationDate, 'MMMM DD, YYYY');
};
